// @flow
import parse from "./parser.js";

type Power = {};

export default function PowerParser(str: string): Power {
  return parse(str);
}
